import { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/";
  const err = sp.get("error");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (err === "google") toast.error("Google sign-in failed", { description: "Please try again or use email instead." });
  }, [err]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" && next === "/" ? "/admin" : next);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign in failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-20">
      <div className="label-eyebrow">Welcome</div>
      <h1 className="font-display text-5xl mt-3 mb-10">Sign in</h1>

      <GoogleButton next={next} testId="login-google-btn" />

      <div className="flex items-center gap-3 my-8">
        <div className="flex-1 h-px bg-[#E5DFD3]" />
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#5C5454]">or</span>
        <div className="flex-1 h-px bg-[#E5DFD3]" />
      </div>

      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="label-eyebrow">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[#E5DFD3] py-3 focus:outline-none focus:border-[#6B1A24]" />
        </div>
        <div>
          <label className="label-eyebrow">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[#E5DFD3] py-3 focus:outline-none focus:border-[#6B1A24]" />
        </div>
        <button data-testid="login-submit" disabled={busy} className="w-full bg-[#6B1A24] text-[#FAFAF7] py-4 uppercase text-xs tracking-[0.25em] hover:bg-[#8A2532] transition-colors disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#5C5454]">
        New here? <Link to="/register" data-testid="login-to-register" className="text-[#6B1A24] underline underline-offset-4">Create an account</Link>
      </p>
    </div>
  );
}
